import { createSelector } from "reselect";
//EXTRACT THE PART OF THE STATE
const getData = state => state.matches.likedMe;

const getPeopleWhoLikedMe = createSelector(getData, likedMe => likedMe);

export default getPeopleWhoLikedMe;



// WEBPACK FOOTER //
// ./src/_selectors/matchesSelectors/getPeopleWhoLikedMe.js